class Accordion {
    constructor() {

        document.querySelectorAll('[data=accordion-trigger]').forEach(function(trigger){

            trigger.addEventListener("click", (event) => {

                const button = event.currentTarget
                const parent = button.closest('[data=accordion-item]')

                parent.classList.toggle("is-active");

                //when button is clicked Change aria-expanded to true
                if(button.ariaExpanded === "true") {
                    button.ariaExpanded = "false";
                } else {
                    button.ariaExpanded = "true";
                }
            });

        });
    }
}

export default Accordion
